export const GOOGLE_MAPS_API_KEY = 'AIzaSyCvrsQ_x5vkSs1Z3sdMR9xKGVgcXGtHOa4';
